import { ItemImgList, ItemList, ItemToolTipList } from "@shared/types";
import { BaseRouteService } from "./BaseRouteService";

export class InventoryService extends BaseRouteService {
    public async inventoryExecute(): Promise<ItemList> {
        return this.getJsonApi<ItemList>("inventory/get-inventory");
    }

    public async inventoryImageExecute(): Promise<ItemImgList> {
        return this.getJsonApi<ItemImgList>("inventory/get-inventory-images");
    }

    public async inventoryTooltipExecute(): Promise<ItemToolTipList> {
        return this.getJsonApi<ItemToolTipList>("inventory/get-inventory-tip");
    }
}
